export default function Spinner({ style }) {
  return (
    <div className="spinner-border text-danger" role="status" style={style}>
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}
